<template>
  <div class="mask">
    <div class="dialog">
      <div class="title">提示</div>
      <div class="row1">系统检测到您的账户信息异常或系统限制，暂时无法使用本店铺。</div>
      <div class="row2">如有疑问，请联系商家：</div>
      <div class="contact row ac" @click="callMobile">
        <img class="contact-icon" :src="phoneIcon" alt="">
        {{ contact }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import phoneIcon from './contactTip/telephone.svg';

const props = defineProps<{contact: string}>();

const callMobile = () => {
  uni.makePhoneCall({
    phoneNumber: props.contact,
    success: () => console.log('拨号界面已调起'),
    fail: (err) => console.error('拨号失败:', err)
  })
}
</script>

<style lang="scss" scoped>
.mask {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.4);
  z-index: 99999;
}
.dialog {
  width: 638rpx;
  background-color: #fff;
  border-radius: 10rpx;
  color: #333;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 32rpx;
  .title {
    text-align: center;
    padding: 24rpx 0;
    line-height: 1.4;
  }
  .row1 {
    padding: 24rpx 32rpx;
    line-height: 1.6;
  }
  .row2 {
    padding: 24rpx 32rpx 0;
    margin-top: 8rpx;
  }
  .contact {
    padding: 0 32rpx 48rpx;
    color: #1E78D2;
    margin-top: 19rpx;
    width: min-content;
    .contact-icon {
      width: 32rpx;
      height: 32rpx;
      margin-right: 4rpx;
    }
  }
}
</style>